<template>
  <div>
    <message :messages="messages"></message>
    <v-card>
      <v-card-title>
        <h3 class="headline">{{labels.general}}</h3>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12 v-if="globalCommonForm.appID === 'MO'">
              <cal-picker v-model="claimForm.reqDate" :label="labels.reqDate" :data-vv-as="labels.reqDate" data-vv-name="reqDate" :error-messages="errors.collect('reqDate')"></cal-picker>
            </v-flex>
            <v-flex lg6 xs12 v-if="globalCommonForm.appID === 'MO'">
              <cal-picker v-model="claimForm.recDate" :label="labels.recDate" :data-vv-as="labels.recDate" data-vv-name="recDate" :error-messages="errors.collect('recDate')"></cal-picker>
            </v-flex>
            <v-flex xs12 v-if="globalCommonForm.appID === 'MO'">
              <v-text-field v-model="claimForm.lossPlace" :label="labels.lossPlace" type="tel" :error-messages="errors.collect('lossPlace')" data-vv-name="lossPlace" :data-vv-as="labels.lossPlace" v-validate="'entry|max:100'"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="claimForm.cseLoss1" :label="labels.cseLoss1" type="tel" :error-messages="errors.collect('cseLoss1')" data-vv-name="cseLoss1" :data-vv-as="labels.cseLoss1" v-validate="'required|entry|max:35'"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="claimForm.cseLoss2" :label="labels.cseLoss2" type="tel" :error-messages="errors.collect('cseLoss2')" data-vv-name="cseLoss2" :data-vv-as="labels.cseLoss2" v-validate="'entry|max:35'"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="claimForm.cseLoss3" :label="labels.cseLoss3" type="tel" :error-messages="errors.collect('cseLoss3')" data-vv-name="cseLoss3" :data-vv-as="labels.cseLoss3" v-validate="'entry|max:35'"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card class="mt-3">
      <v-card-title>
        <h3 class="headline">{{labels.claimants}}</h3>
        <v-spacer></v-spacer>
        <v-btn color="secondary" v-if="!claimantSection" @click.prevent="doAddClaimant">
          Add Claimant
          <v-icon right>mdi-account-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-data-table :headers="claimantColumns" :items="claimForm.claimants" class="elevation-1" :no-data-text="noDataText" hide-actions>
        <template slot="items" slot-scope="props">
          <td>{{props.index + 1}}</td>
          <td>{{props.item.clmtName}}</td>
          <td>{{props.item.clmtNricPassport}}</td>
          <td>{{props.item.clmtRocUen}}</td>
          <td>{{formatDisplayDate(props.item.clmtDob)}}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review :query="false" :remove="!claimantSection" @remove="doPromptRemove(props)" @review="doEditClaimant(props)" :loading="loading"></table-action>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <v-layout row wrap class="pt-3">
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed" v-if="renderSummary">
        Proceed to Summary
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
    <v-card class="mt-3" v-if="claimantSection" id="claimantCard">
      <v-card-title>
        <div class="body-2">{{labels.claimantInfo}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12>
              <v-radio-group row :label="labels.clmtStatus" v-model="claimant.clmtStatus" :error-messages="errors.collect('clmtStatus')" data-vv-name="clmtStatus" :data-vv-as="labels.clmtStatus" v-validate="'required'" @change="doClmtStatus">
                <v-radio v-for="status in claimantStatusList" :key="status.value" :label="status.label" :value="status.value"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex lg6 xs12 v-if="claimant.clmtStatus === 'I'">
              <v-autocomplete :items="salutationList" v-model="claimant.clmtSalutation" :label="labels.clmtSalutation" item-text="label" item-value="value" data-vv-name="clmtSalutation" :data-vv-as="labels.clmtSalutation" :error-messages="errors.collect('clmtSalutation')" v-validate="'required'"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12 v-if="claimant.clmtStatus === 'I'"></v-flex>
            <v-flex lg6 xs12 v-if="claimant.clmtStatus === 'I'">
              <v-text-field key="clmtName" v-model="claimant.clmtName" :label="labels.clmtName" :error-messages="errors.collect('clmtName')" data-vv-name="clmtName" :data-vv-as="labels.clmtName" v-validate="'required|name|max:50'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12 v-if="claimant.clmtStatus === 'I'">
              <v-text-field v-uppercase="claimant.clmtNricPassport" v-model="claimant.clmtNricPassport" :label="labels.clmtNricPassport" :error-messages="errors.collect('clmtNricPassport')" data-vv-name="clmtNricPassport" :data-vv-as="labels.clmtNricPassport" v-validate="'alpha_num|max:20'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12 v-if="claimant.clmtStatus === 'I'">
              <cal-picker v-model="claimant.clmtDob" :label="labels.clmtDob" :data-vv-as="labels.clmtDob" data-vv-name="clmtDob" :error-messages="errors.collect('clmtDob')"></cal-picker>
            </v-flex>
            <v-flex lg6 xs12 v-if="claimant.clmtStatus === 'E'">
              <v-text-field key="clmtCoyName" v-model="claimant.clmtName" :label="labels.clmtCoyName" :error-messages="errors.collect('clmtCoyName')" data-vv-name="clmtCoyName" :data-vv-as="labels.clmtCoyName" v-validate="'required|name|max:50'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12 v-if="claimant.clmtStatus === 'E'">
              <v-text-field v-model="claimant.clmtRocUen" :label="labels.clmtRocUen" :error-messages="errors.collect('clmtRocUen')" data-vv-name="clmtRocUen" :data-vv-as="labels.clmtRocUen" v-validate="'entry|max:20'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12 v-if="globalCommonForm.appID === 'MO'">
              <v-text-field v-model="claimant.vehRegNo" v-uppercase="claimant.vehRegNo" :label="labels.vehRegNo" :error-messages="errors.collect('vehRegNo')" data-vv-name="vehRegNo" :data-vv-as="labels.vehRegNo" v-validate="'veh_reg_no|max:8'"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-title>
        <div class="body-2">{{labels.mailAddress}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-text-field v-model="claimant.clmtAdd3" :label="labels.clmtAdd3" :error-messages="errors.collect('clmtAdd3')" data-vv-name="clmtAdd3" :data-vv-as="labels.clmtAdd3" prefix="#" v-validate="'unit_no|max:30'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="claimant.clmtPostalCode" :label="labels.clmtPostalCode" v-int-mask="{intScale: 6}" type="tel" :error-messages="errors.collect('clmtPostalCode')" data-vv-name="clmtPostalCode" :data-vv-as="labels.clmtPostalCode" v-validate="'numeric'" :loading="clmtPostalCodeLoading" @change="doClmtAddress"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="claimant.clmtAdd1" :label="labels.clmtAdd1" :error-messages="errors.collect('clmtAdd1')" data-vv-name="clmtAdd1" :data-vv-as="labels.clmtAdd1" v-validate="'entry|max:30'" ></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="claimant.clmtAdd2" :label="labels.clmtAdd2" :error-messages="errors.collect('clmtAdd2')" data-vv-name="clmtAdd2" :data-vv-as="labels.clmtAdd2" v-validate="'entry|max:255'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="claimant.clmtAdd4" :label="labels.clmtAdd4" :error-messages="errors.collect('clmtAdd4')" data-vv-name="clmtAdd4" :data-vv-as="labels.clmtAdd4" v-validate="'entry|max:255'"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-title>
        <div class="body-2">{{labels.clmtContact}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-text-field v-model="claimant.clmtEmail" type="email" :label="labels.clmtEmail" :error-messages="errors.collect('clmtEmail')" data-vv-name="clmtEmail" :data-vv-as="labels.clmtEmail" v-validate="'email'" prepend-icon="mdi-email" hint="An email acknowledgement will be sent to this address" :persistent-hint="true"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12></v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="claimant.clmtMobileNo" v-int-mask="{intScale: 8}" type="tel" :label="labels.clmtMobileNo" :error-messages="errors.collect('clmtMobileNo')" data-vv-name="clmtMobileNo" :data-vv-as="labels.clmtMobileNo" v-validate="'numeric'" prepend-icon="mdi-phone"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="claimant.clmtTelNo1" v-int-mask="{intScale: 8}" type="tel" :label="labels.clmtTelNo1" :error-messages="errors.collect('clmtTelNo1')" data-vv-name="clmtTelNo1" :data-vv-as="labels.clmtTelNo1" v-validate="'numeric'" prepend-icon="mdi-phone"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="claimant.clmtTelNo2" v-int-mask="{intScale: 8}" type="tel" :label="labels.clmtTelNo2" :error-messages="errors.collect('clmtTelNo2')" data-vv-name="clmtTelNo2" :data-vv-as="labels.clmtTelNo1" v-validate="'numeric'" prepend-icon="mdi-phone"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="claimant.clmtFaxNo" v-int-mask="{intScale: 8}" type="tel" :label="labels.clmtFaxNo" :error-messages="errors.collect('clmtFaxNo')" data-vv-name="clmtFaxNo" :data-vv-as="labels.clmtFaxNo" v-validate="'numeric'" prepend-icon="mdi-phone"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat="flat" @click.native="claimantSection = false">Cancel</v-btn>
        <v-btn color="primary" flat="flat" type="submit" @click="doSaveClaimant">Next</v-btn>
      </v-card-actions>
    </v-card>
    <confirm v-model="promptRemoveClaimant" @ok="doRemoveClaimant">
      All claim details and payment items under this Claimant will be removed.
    </confirm>
  </div>
</template>

<script>
import { CLAIMS_CLAIMDETAIL_LIFECYCLE, CLAIMS_CLAIMDETAIL_CLAIMANT } from '@/store/types'
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import { salutation, claimantStatus } from '@/const/claims'
import { expandURI } from '@/utils/ajax'
import clone from 'clone'
import { formatDisplayDate } from '@/utils/date'
import { SaveClaimMixin } from '../saveClaimMixin'

export default {
  data() {
    return {
      labels: {
        general: 'General Information',
        claimants: 'Claimants',
        claimantInfo: 'Claimant Information',
        clmtStatus: 'Claimant Status*',
        clmtSalutation: 'Claimant Salutation*',
        clmtName: 'Name as in NRIC/Passport*',
        clmtNricPassport: 'NRIC/Passport*',
        clmtCoyName: 'Company Name*',
        clmtRocUen: 'ROC/UEN',
        clmtDob: 'Date of Birth*',
        vehRegNo: 'Vehicle Registration No.',
        mailAddress: 'Mailing Address',
        clmtAdd1: 'Block/House No.*',
        clmtAdd2: 'Street Name*',
        clmtAdd3: 'Unit No.',
        clmtAdd4: 'Building Name',
        clmtPostalCode: 'Postal Code*',
        clmtContact: 'Contacts',
        clmtEmail: 'Email*',
        clmtMobileNo: 'Mobile No.*',
        clmtTelNo1: 'Home No.',
        clmtTelNo2: 'Office No.',
        clmtFaxNo: 'Fax No.',
        ackDate: 'Acknowledge Date*',
        reqDate: 'Required Date',
        recDate: 'Received Date',
        lossPlace: 'Loss Place',
        cseLoss1: 'Cause of Loss*',
        cseLoss2: '',
        cseLoss3: ''
      },
      claimForm: {
        reqDate: undefined,
        recDate: undefined,
        lossPlace: undefined,
        cseLoss1: undefined,
        cseLoss2: undefined,
        cseLoss3: undefined,
        claimants: [],
        selectedClaimant: undefined
      },
      claimant: {
        clmtNo: undefined,
        clmtStatus: undefined,
        clmtSalutation: undefined,
        clmtName: undefined,
        clmtNricPassport: undefined,
        clmtRocUen: undefined,
        clmtDob: undefined,
        clmtAdd1: undefined,
        clmtAdd2: undefined,
        clmtAdd3: undefined,
        clmtAdd4: undefined,
        clmtPostalCode: undefined,
        clmtEmail: undefined,
        clmtMobileNo: undefined,
        clmtTelNo1: undefined,
        clmtTelNo2: undefined,
        clmtFaxNo: undefined,
        vehRegNo: undefined,
        clmItems: []
      },
      claimantSection: false,
      clmtPostalCodeLoading: false,
      promptRemoveClaimant: false
    }
  },
  computed: {
    globalCommonForm() {
      return this.$store.state.claims.claimDetail.commonForm
    },
    globalClaimForm() {
      return this.$store.state.claims.claimDetail.claimForm
    },
    claimantColumns() {
      return [
        { text: 'No.', align: 'left', sortable: false, value: 'clmtNo' },
        { text: 'Name', align: 'left', sortable: false, value: 'clmtName' },
        { text: 'NRIC/Passport', sortable: false, value: 'clmtNricPassport' },
        { text: 'ROC/UEN', sortable: false, value: 'clmtRocUen' },
        { text: 'Date of Birth', sortable: false, value: 'clmtDob' },
        TableConst.tableActionHeader
      ]
    },
    claimantStatusList() {
      // Convert object to arr
      let result = []
      Object.keys(claimantStatus).forEach(function (key) {
        const status = claimantStatus[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    salutationList() {
      let result = []
      Object.keys(salutation).forEach(function (key) {
        const status = salutation[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    renderSummary() {
      if (this.claimForm.claimants && this.claimForm.claimants.length > 0) {
        if (this.claimantSection === true) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    }
  },
  methods: {
    doInit() {
      // Default value from vuex store 1st
      this.claimForm.reqDate = this.globalCommonForm.reqDate
      this.claimForm.recDate = this.globalCommonForm.recDate
      this.claimForm.lossPlace = this.globalCommonForm.lossPlace
      this.claimForm.cseLoss1 = this.globalCommonForm.cseLoss1
      this.claimForm.cseLoss2 = this.globalCommonForm.cseLoss2
      this.claimForm.cseLoss3 = this.globalCommonForm.cseLoss3
      // Claimants
      this.claimForm.claimants = clone(this.globalClaimForm.claimants)
    },
    doAddClaimant() {
      // Init the Claimant details
      this.resetValidator()
      if (this.claimantSection !== true) {
        if (!this.claimant.clmtStatus && this.claimantStatusList && this.claimantStatusList.length > 0) {
          // Default 1st value if not found
          this.claimant.clmtStatus = this.claimantStatusList[0].value
        }
        this.claimant.clmtNo = undefined
        this.claimant.clmtSalutation = undefined
        this.claimant.clmtName = undefined
        this.claimant.clmtNricPassport = undefined
        this.claimant.clmtRocUen = undefined
        this.claimant.clmtDob = undefined
        this.claimant.clmtAdd1 = undefined
        this.claimant.clmtAdd2 = undefined
        this.claimant.clmtAdd3 = undefined
        this.claimant.clmtAdd4 = undefined
        this.claimant.clmtPostalCode = undefined
        this.claimant.clmtEmail = undefined
        this.claimant.clmtMobileNo = undefined
        this.claimant.clmtTelNo1 = undefined
        this.claimant.clmtTelNo2 = undefined
        this.claimant.clmtFaxNo = undefined
        this.claimant.vehRegNo = undefined
        this.claimant.clmItems = []
        this.claimantSection = true
        this.$nextTick(() => {
          this.$vuetify.goTo('#claimantCard')
        })
      }
    },
    doPromptRemove(props) {
      this.claimForm.selectedClaimant = props
      this.promptRemoveClaimant = true
    },
    doRemoveClaimant() {
      if (this.claimForm.selectedClaimant && this.claimForm.selectedClaimant.index !== null) {
        this.claimForm.claimants.splice(this.claimForm.selectedClaimant.index, 1)
      }
    },
    doEditClaimant(props) {
      // Init the Claimant details
      this.claimant.clmtNo = props.index
      this.claimant.clmtStatus = props.item.clmtStatus
      this.claimant.clmtSalutation = props.item.clmtSalutation
      this.claimant.clmtName = props.item.clmtName
      this.claimant.clmtNricPassport = props.item.clmtNricPassport
      this.claimant.clmtRocUen = props.item.clmtRocUen
      this.claimant.clmtDob = props.item.clmtDob
      this.claimant.clmtAdd1 = props.item.clmtAdd1
      this.claimant.clmtAdd2 = props.item.clmtAdd2
      this.claimant.clmtAdd3 = props.item.clmtAdd3
      this.claimant.clmtAdd4 = props.item.clmtAdd4
      this.claimant.clmtPostalCode = props.item.clmtPostalCode
      this.claimant.clmtEmail = props.item.clmtEmail
      this.claimant.clmtMobileNo = props.item.clmtMobileNo
      this.claimant.clmtTelNo1 = props.item.clmtTelNo1
      this.claimant.clmtTelNo2 = props.item.clmtTelNo2
      this.claimant.clmtFaxNo = props.item.clmtFaxNo
      this.claimant.vehRegNo = props.item.vehRegNo
      this.claimant.clmItems = props.item.clmItems
      this.resetValidator()
      this.claimantSection = true
      this.$nextTick(() => {
        this.$vuetify.goTo('#claimantCard')
      })
    },
    doClmtStatus() {
      // Reset some values
      if (this.claimant.clmtStatus && this.claimant.clmtStatus === 'E') {
        this.claimant.clmtNricPassport = undefined
        this.claimant.clmtDob = undefined
      } else if (this.claimant.clmtStatus && this.claimant.clmtStatus === 'I') {
        this.claimant.clmtRocUen = undefined
      }
    },
    async doClmtAddress() {
      const apiUrl = this.$store.state.claims.claimDetail.menu.address
      if (apiUrl) {
        try {
          this.clmtPostalCodeLoading = true
          const expand = {
            postCode: this.claimant.clmtPostalCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.claimant.clmtAdd1 = data.add1
            this.claimant.clmtAdd2 = data.add2
            this.claimant.clmtAdd4 = data.add4
          }
          this.clmtPostalCodeLoading = false
        } catch (err) {
          this.clmtPostalCodeLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doSaveClaimant() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.claimant.clmtNo === undefined) {
            // New Claimant
            this.claimant.clmtNo = this.claimForm.claimants.length
            this.claimForm.claimants.push(clone(this.claimant))
            this.claimantSection = false
          } else {
            // Update Claimant
            this.$set(this.claimForm.claimants, this.claimant.clmtNo, clone(this.claimant))
            this.claimantSection = false
          }
          this.claimForm.selectedClaimant = this.claimant
          this.$store.commit(CLAIMS_CLAIMDETAIL_CLAIMANT, this.claimForm)
          this.$store.commit(CLAIMS_CLAIMDETAIL_LIFECYCLE, 2)
          this.$router.push({ name: 'claimDetailItem' })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doProceed() {
      this.resetMessages()
      this.$store.commit(CLAIMS_CLAIMDETAIL_LIFECYCLE, 4)
      this.$router.push({ name: 'claimDetailSummary' })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        this.$store.commit(CLAIMS_CLAIMDETAIL_CLAIMANT, this.claimForm)
        await this.$store.dispatch('saveClaim')
        return true
      } catch (err) {
        return false
      }
    },
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.claims.claimDetail.claimLifeCycle !== 1) {
      this.$store.commit(CLAIMS_CLAIMDETAIL_LIFECYCLE, 1)
    }
    this.doInit()
  },
  mixins: [
    MessageMixin,
    TableConst.default,
    SaveClaimMixin
  ]
}
</script>

<style lang="scss">
</style>
